import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from 'src/app/shareModule/services/customer.service';

@Component({
    selector: 'app-menu-options',
    templateUrl: './menu-options.component.html',
    styleUrls: ['./menu-options.component.scss']
})
export class MenuOptionsComponent {

    constructor(
        private modalService: NgbModal,
        private sharedService: SharedService,
        private local: LocalServiceService,
        private auth: AuthServiceService,
        private toastr: ToastrService,
        private customerService: CustomerService
    ) { }
    @ViewChild('menuOptions', { static: false }) menuOptions: any;
    tabMenu: number = 0;
    @Input() appUserId: number = 0;
    @Input() areThereNewMessages: boolean = false;
    isUserLogin: boolean = false;
    surveyCount: number = 0;
    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['appUserId']) {
            this.isUserLogin = changes['appUserId'].currentValue !== 0;
        }
    }

    public openMenuOptionsModal() {

        this.customerService.checkSurvey({ userId: this.appUserId }).subscribe((res: any) => {
            this.surveyCount = res.body;
        });
        this.modalService.open(this.menuOptions, {
            windowClass: 'my-modal md menu-2',
        });
    }
    public openWhatsapp(){
       // 
       if(this.sharedService.isBrowser() && window.location.href.includes('/map')){
           this.sharedService.openWhatsapp.next()
       }else{
        window.open(`https://wa.me/+6581207644`, '_blank');
       }
      
    }

    public openAIChat() {
        this.sharedService.triggerChatNow({
            chatingNow: 'ai',
            menu: 'chat',
            chatTitle: 'Loading...',
        });
    }

    handleReport(id: any = 0, category = 'system_report') {
        this.local.alertReport().then((result) => {
            if (result.isConfirmed && result.value) {
                const report = result.value;
                this.auth
                    .submitReportMessage({
                        message: report.reportDetails,
                        type: report.reportType,
                        category: category,
                        product_id: id,
                    })
                    .subscribe(
                        (response: any) => {
                            this.toastr.success('Reported successfully');
                        },
                        (e) => {
                            this.toastr.error(e.error.message);
                        }
                    );
            }
        });
    }

}
